export const FLAG_GETTING_ODOMETER_BY_BUS = 'FLAG_GETTING_ODOMETER_BY_BUS';
export const GET_ODOMETER_BY_BUS = 'GET_ODOMETER_BY_BUS';
export const CLEAR_ODOMETER_BY_BUS = 'CLEAR_ODOMETER_BY_BUS';
